// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"e451b823","183":"e13ce8d1","351":"c5af6898","357":"1398a9cd","428":"eee3a184","685":"8aa003fd","695":"abd8bfa3","851":"f6e0f8da","882":"1de2fd01","929":"a74de610"}[chunkId] + ".chunk.js";
};